import { tagging as taggingList } from './taggingData';
import { getCookie, getdeviceType, getSession, isNotEmpty, getLqDetails, isVHILiteQualified } from '.';
import { FWA_CONSTANTS } from '../constants';

export const getThrottleKeys = (throttleValues, pageName) => {
  if (!taggingList || taggingList.length === 0 || !throttleValues || !pageName) {
    return [];
  }

  const pageTaggingList = taggingList.filter((item) => item.pageName === pageName && item.throttle && item.throttle.length > 0);

  if (pageTaggingList && pageTaggingList[0] && pageTaggingList[0].throttle) {
    const availableTaggingList = pageTaggingList[0].throttle.filter((item) => throttleValues.includes(item.key));

    if (!availableTaggingList || availableTaggingList.length === 0) {
      return [];
    }

    const throttleKeys = [...new Set(availableTaggingList.map((x) => x.value))];
    return throttleKeys;
  }

  return [];
};

export const populateLqStateValue = (networkBandwidthType, isCBand, isVHILite = false) => {
  const productsQualified = [];
  try {
    if (networkBandwidthType === 'lte') {
      productsQualified.push(isVHILite ? 'vhi lite' : 'lte');
    } else {
      productsQualified.push(`5g|${isCBand ? 'cband' : 'mmWave'}`);
    }
    return productsQualified;
  } catch (e) {
    console.log('populateLqStateValue');
  }
};
const getLqWidgetFlow = () => {
  const role = getCookie('role');
  return role === 'guest' ? 'lq widget|guest' : 'lq widget';
};

const appendloopQualVzTagTags = (subFlowName) => {
  let result = subFlowName;
  const autoLocationPromptGeo = getSession('autoLocationPromptGeo') || '';
  if (autoLocationPromptGeo) {
    result += '|prompt geo';
  }
  return result;
};
export const loopQualVzTaglqs = async (isStreamline = false) => {
  let hashedAddressIdVal = '';
  let locusId = '';
  let isCBand = false;
  let zip_Code = '';
  let digital_SessionId = '';
  let newAddressId = '';
  let network_BandwidthType = '';
  let isVHILite = false;
  const response = getSession('LQResponse');
  if (isNotEmpty(response)) {
    const responseObj = JSON.parse(response);
    if (responseObj && responseObj.output) {
      if (isNotEmpty(responseObj.output.hashedLocusId)) {
        hashedAddressIdVal = responseObj.output.hashedLocusId;
      }
      if (responseObj.output?.networkBandwidthType === 'cbd') {
        isCBand = true;
      }
      const { zipCode, digitalSessionId, networkBandwidthType, VHILiteQualified } = responseObj.output || {};
      zip_Code = zipCode;
      digital_SessionId = digitalSessionId;
      network_BandwidthType = networkBandwidthType;
      isVHILite = VHILiteQualified || false;
      if (responseObj.output?.addressId) {
        locusId = isNotEmpty(responseObj.output.addressId) ? responseObj.output.addressId : locusId;
        newAddressId = locusId && locusId !== '' ? locusId : newAddressId;
      } else if (responseObj.output?.subLocationId) {
        locusId = isNotEmpty(responseObj.output.subLocationId) ? responseObj.output.subLocationId : locusId;
        newAddressId = locusId && locusId !== '' ? locusId : newAddressId;
      }
    }
  }
  if (hashedAddressIdVal === '' && newAddressId !== '') {
    const keyValue = `${newAddressId}${FWA_CONSTANTS.shaKey}`;
    try {
      const msgUint8 = new TextEncoder().encode(keyValue);
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      hashedAddressIdVal = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    } catch (error) {
      console.error('getSHA-256 failed', error);
    }
  }
  let subFlow = '';
  subFlow = appendloopQualVzTagTags(subFlow);
  const throttleList = getCookie('cdlThrottleList') || getSession('LqThrottle') ? getSession('LqThrottle') : '';
  const dataObject = {
    version: 2,
    type: 'lqs',
    zip: zip_Code,
    hashedAddress: hashedAddressIdVal,
    errorMessage: '',
    detail: getLqResult(),
    eligible: populateLqStateValue(network_BandwidthType, isCBand, isVHILite),
    data: {
      page: {
        flow: getLqWidgetFlow(),
        throttle: 'nsa version|vhi home',
        zip: zip_Code,
        LQZip: zip_Code,
        channel: 'Ordering',
        displayChannel: 'VZW',
        sourceChannel: 'VZW',
        channelSession: digital_SessionId,
        applicationName: getdeviceType(),
        subFlow,
        subCategory: getSession('lq4') ? 'LQ 4.0' : 'LQ 3.0',
        name: isStreamline ? 'progressiveplans streamlineordering' : 'progressiveplans', // streamline
      },
      user: {
        authStatus: getCookie('loggedIn') || getCookie('userinfo') ? 'logged in' : 'anonymous',
        accountType: getCookie('loggedIn') || getCookie('userinfo') ? 'existing customer' : 'new customer',
        session: getCookie('GLOBALID'),
        zip: zip_Code,
      },
      target: {
        offer: '',
        engagement: {
          intent: 'Ordering',
        },
        message: '',
        sandBox: throttleList,
      },
      utils: {
        rtm: {
          locusId,
          prospectEmail: '',
          mtn: '',
        },
      },
      env: {
        businessUnit: 'Wireless',
      },
    },
    discount_mh_ec: false,
    discount_mh_nc: false,
  };
  window.vzdl = dataObject.data;
  if (window.VZTAG_IS_READY) {
    window.vztag.api.dispatch('loopQual', dataObject);
  } else {
    document.addEventListener(
      'vztagReady',
      (function vztagApi(VapiName, Vobj) {
        return () => {
          window.vztag.api.dispatch(VapiName, Vobj);
        };
      })('loopQual', dataObject),
    );
  }
  invokeCoreDataLqs(true);
};
const getLqResult = () => {
  const response = getSession('LQResponse');
  const { networkBandwidthType, VHILiteQualified } =
    (isNotEmpty(response) && JSON.parse(response)?.output) || {};

  if (networkBandwidthType === 'lte') {
    return VHILiteQualified
      ? 'lq result - vhi lite eligible'
      : 'lq result - lte eligible';
  }

  return `lq result - 5G eligible -${getProductType(networkBandwidthType)}`;
};
const getProductType = (networkBandwidthType) => {
  if (networkBandwidthType === 'tgw') return 'tgw';
  if (networkBandwidthType === 'cbd') return 'cband';
  return 'mmWave';
};
const appendPassiveLQTags = (subFlowName) => {
  let result = subFlowName;
  const passiveLQAsubFlow = getSession('passiveLQAsubFlow') || '';
  if (passiveLQAsubFlow) {
    result += `|${passiveLQAsubFlow}`;
  }
  return result;
};

const getPassiveProductsQualified = (networkBandwidthType, isVHILiteQual) => {
  if (networkBandwidthType === 'lte' && isVHILiteQual) {
    return 'vhi lite';
  }
  return networkBandwidthType || '';
};

export const passiveVzTagLqs = async () => {
  let zip_Code = '';
  let digital_SessionId = '';
  let network_BandwidthType = '';
  let isCBand = false;
  let bulkQual_AddressType = '';
  let subFlow = '';
  let isVHILiteQual = false;
  const response = getSession('LQResponse');
  if (isNotEmpty(response)) {
    const responseObj = JSON.parse(response);
    if (responseObj && responseObj.output) {
      if (responseObj.output?.networkBandwidthType === 'cbd') {
        isCBand = true;
      }
      const { zipCode, digitalSessionId, networkBandwidthType, bulkQualAddressType, VHILiteQualified } = responseObj.output || {};
      isVHILiteQual = VHILiteQualified;
      zip_Code = zipCode;
      digital_SessionId = digitalSessionId;
      network_BandwidthType = networkBandwidthType;
      bulkQual_AddressType = bulkQualAddressType;
    }
  }
  const throttleList = getCookie('cdlThrottleList') || getSession('LqThrottle') ? getSession('LqThrottle') : '';
  const event = bulkQual_AddressType === 'BillAccount' ? 'event337' : 'event338';
  subFlow = bulkQual_AddressType === 'GEO_LOCATION' ? 'plqs-geo' : '';
  subFlow = appendPassiveLQTags(subFlow);
  const dataObject = {
    name: 'passive lq',
    data: {
      page: {
        flow: getLqWidgetFlow(),
        subFlow,
        throttle: 'nsa version|vhi home',
        channel: 'Ordering',
        zip: zip_Code,
        LQZip: zip_Code,
        detail: getPassiveLqsDetails(network_BandwidthType, isCBand, isVHILiteQual),
        channelSession: digital_SessionId,
        applicationName: getdeviceType(),
        displayChannel: 'VZW',
        sourceChannel: 'VZW',
        subCategory: getSession('lq4') ? 'LQ 4.0' : 'LQ 3.0',
        name: 'progressiveplans',
      },
      user: {
        authStatus: getCookie('loggedIn') || getCookie('userinfo') ? 'logged in' : 'anonymous',
        accountType: getCookie('loggedIn') || getCookie('userinfo') ? 'existing customer' : 'new customer',
        session: getCookie('GLOBALID'),
        productsQualified: getPassiveProductsQualified(network_BandwidthType, isVHILiteQual),
        zip: zip_Code,
      },
      event: {
        value: `event334,${event}`,
      },
      target: {
        engagement: {
          intent: 'Ordering',
        },
        sandBox: throttleList,
      },
    },
  };
  window.vzdl = dataObject.data;
  if (window.VZTAG_IS_READY) {
    window.vztag.api.dispatch('sendData', dataObject);
  } else {
    document.addEventListener(
      'vztagReady',
      (function vztagApi(VapiName, Vobj) {
        return () => {
          window.vztag.api.dispatch(VapiName, Vobj);
        };
      })('sendData', dataObject),
    );
  }
  invokeCoreDataLqs(false);
};

const getPassiveLqsDetails = (networkBandwidthType, isCBand, VHILiteQualified) => {
  if (networkBandwidthType === 'lte' && VHILiteQualified) {
    return 'plq result -single vhi lite eligible';
  }
  if (networkBandwidthType === 'lte') {
    return 'plq result -single lte eligible';
  }
  return `plq result -single 5G eligible - ${isCBand ? 'cband' : 'mmWave'}`;
}

const getProductQualifiedResponse = () => {
  const { qualifiedCBand, qualified4GHome, qualified, qualifiedLte, tanglewoodQualified } = getLqDetails() || {};
  const response = [];
  if (qualifiedCBand) {
    response.push({ qualified: ['5g-cband'] });
  } else if (qualified) {
    response.push({ qualified: ['5g-mmwave'] });
  }
  if (qualified4GHome || qualifiedLte) {
    response.push({ qualified: ['lte-home'] });
  }
  if (tanglewoodQualified) {
    response.push({ qualified: ['tgw'] });
  }
  if (isVHILiteQualified()) {
    response.push({ qualified: ['vhi-lite'] });
  }
  return response;
};

export const invokeCoreDataLqs = (isActive) => {
  const response = getProductQualifiedResponse();
  window.coreData = window.coreData || [];
  window.coreData.push({
    task: 'emit',
    event: 'loopQualV2',
    params: {
      action: 'success',
      position: 'widget',
      triggerPage: window.sessionStorage.getItem('triggerPage'),
      passive: !isActive,
      version: '2.0',
      geoUsed: window.sessionStorage.getItem('isGeo') === 'Y',
      response,
    },
  });
};